import { EAccountStatus, IAccount } from '../types';

/**
 * Returns the first active account or the first account if none are active
 */
export function findInitialAccount(accounts: IAccount[]) {
  for (const account of accounts) {
    if (account.status === EAccountStatus.active) {
      return account;
    }
  }

  return accounts[0];
}
